/*
Luke Harby
slackwise LTD
https://slackwise.org.uk
2012 - present
*/
import { DOM } from './global';
import { toggleVisibility } from './toggleVisibility'

/* attachKeyEvent function */
const elems = document.querySelectorAll('.search-wrapper');

const attachKeyEvent = () => {
    DOM.addEventListener('keydown', (e) => {
        if (e.key === 'x' || e.key === 'X') {
            toggleVisibility(elems);
        }
    });
};

export { attachKeyEvent };